<template>
  <div class="props-group">
      <div class="discriminate">
        <el-form-item label="识别地址">
          <el-checkbox v-model="discriminate.recognizeAddr"></el-checkbox>
        </el-form-item>
        <el-form-item label="识别性别">
          <el-checkbox v-model="discriminate.recognizeSex"></el-checkbox>
        </el-form-item>
        <el-form-item label="识别生日">
          <el-checkbox v-model="discriminate.recognizeBirthday"></el-checkbox>
        </el-form-item>
        <el-form-item label="识别年龄">
          <el-checkbox v-model="discriminate.recognizeAge"></el-checkbox>
        </el-form-item>
      </div>
  </div>
</template>

<script>
import { UUID } from '@/plugins/common'
import {getProperties} from '@/store/form/componentDefaults.js'

export default {
  name: 'attr-discern',
  props: [ 'component' ],
  inject: ['formService'],
  data () {
    return {
      discriminate: {
        recognizeAddr: false,
        recognizeSex: false,
        recognizeBirthday: false,
        recognizeAge: false
      }
    }
  },
  mounted () {
    for (let attr in this.discriminate) {
      this.discriminate[attr] = this.component.properties.discriminate[attr] !== ''
    }
  },
  methods: {
    saveAttr () {
      let addComponent = []
      let removerComponent = []
      for (let attr in this.discriminate) {
        if (this.discriminate[attr]) {
          // 如果勾中选项
          if (this.component.properties.discriminate[attr] === '') {
            // 该属性不存在对应子控件, 记录下来, 用于增加子控件
            addComponent.push(attr)
          }
        } else {
          // 如果取消选项
          if (this.component.properties.discriminate[attr] !== '') {
            // 该控件之前存在对应子控件, 记录下来, 用于删除子控件
            removerComponent.push(this.component.properties.discriminate[attr])
            this.component.properties.discriminate[attr] = ''
          }
        }
      }

      let parentComponent = this.formService.getParentComponent(this.component)

      addComponent.forEach(async (m, index) => {
        let component = childrenComponent[m]
        let name = component.defaults.name
        component = getProperties('rc-children-input')
        component.defaults.id = UUID.create()
        component.defaults.name = name
        this.component.properties.discriminate[m] = component.defaults.id
        let pinyin = await this.formService.getPinyinByHanzi(component.defaults.name)
        component.defaults.pinyinName = pinyin.pinyinName
        component.defaults.pinyinFirstChar = pinyin.pinyinFirstChar
        let cm = this.formService.createComponent(component, parentComponent)
        this.$nextTick(() => {
          let table = this.formService.schema.getTable(cm.archive.tableId)
          // 表格不需要改列的值
          if (cm.componentType === 'rc-table') {
            table.pinyinName = pinyin.pinyinName
            table.pinyinFirstChar = pinyin.pinyinFirstChar
          } else {
            if (table && table.columns) {
              let c = table.columns.find(c => c.id === cm.archive.columnId)
              c.pinyinName = pinyin.pinyinName
              c.pinyinFirstChar = pinyin.pinyinFirstChar
            }
          }
        })
      })
      removerComponent.forEach(m => {
        let component = this.formService.getComponentById(m)
        this.formService.removeComponent(component)
      })
    }
  }
}
const childrenComponent = {
  recognizeAddr: {
    defaults: {
      name: '地址'
    }
  },
  recognizeSex: {
    defaults: {
      name: '性别'
    }
  },
  recognizeBirthday: {
    defaults: {
      name: '生日'
    }
  },
  recognizeAge: {
    defaults: {
      name: '年龄'
    }

  }
}
</script>

<style lang="scss">
  .discriminate {
    border-top: 1px solid #c2c3c4;
    margin: 0 -20px;
    padding: 0 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/discern.vue